// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SaveNoticeOfIntentChangeRequestWorkForceLinkDetailHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import NoticeOfIntentChangeRequestWorkForceLinkDTO from '../models/NoticeOfIntentChangeRequestWorkForceLinkDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    noticeOfIntentChangeRequestWorkForceLinkId: string | null;
    url: string | null;
    title: string | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            noticeOfIntentChangeRequestWorkForceLinkId: '00000000-0000-0000-0000-000000000000',
            url: "",
            title: "",
        },
        initValues);
    },
    noticeOfIntentChangeRequestWorkForceLinkId: 'noticeOfIntentChangeRequestWorkForceLinkId',
    url: 'url',
    title: 'title',
}

interface Result extends ResultDTO {
    noticeOfIntentChangeRequestWorkForceLink: NoticeOfIntentChangeRequestWorkForceLinkDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            noticeOfIntentChangeRequestWorkForceLink: null,
        },
        initValues);
    },
    noticeOfIntentChangeRequestWorkForceLink: 'noticeOfIntentChangeRequestWorkForceLink',
}

export { Request, Result };